import {initWebComponent} from "@/helpers/web-component-helper";
import {LayerInfoButtonComponent} from "@/components/layer/info/buttons/layer-info-button-component";
import {
    LayerInfoCharacteristicsButtonComponent
} from "@/components/layer/info/buttons/layer-info-characteristics-button-component";
import {LayerInfoInfoButtonComponent} from "@/components/layer/info/buttons/layer-info-info-button-component";
import {LayerInfoLegendButtonComponent} from "@/components/layer/info/buttons/layer-info-legend-button-component";
import {LayerInfoFilterButtonComponent} from "@/components/layer/info/buttons/layer-info-filter-button-component";
import {BookmarkInfoComponent} from "@/components/bookmark/bookmark-info-component";
import {BookmarkRightMouseButtonsComponent} from "@/components/bookmark/bookmark-right-mouse-buttons-component";
import {BookmarkPrintComponent} from "@/components/bookmark/bookmark-print-component";
import {hideLayerInfoForm, initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {LayerInfoCharacteristicsComponent} from "@/components/layer/info/layer-info-characteristics-component";
import {initInteract} from "@/helpers/interact-helper";
import {LayerInfoInfoComponent} from "@/components/layer/info/layer-info-info-component";
import {LayerInfoLegendComponent} from "@/components/layer/info/layer-info-legend-component";
import {LayerInfoFilterComponent} from "@/components/layer/info/layer-info-filter-component";
import {LayerInfoMutationComponent} from "@/components/layer/info/layer-info-mutation-component";
import {LayerInfoToolsComponent} from "@/components/layer/info/layer-info-tools-component";
import {LayerInfoToolsButtonComponent} from "@/components/layer/info/buttons/layer-info-tools-button-component";
import {LayerInfoInfoItemComponent} from "@/components/layer/info/info/layer-info-info-item-component";
import {LayerInfoInfoItemHeaderComponent} from "@/components/layer/info/info/layer-info-info-item-header-component";
import {LayerInfoInfoItemGeometryComponent} from "@/components/layer/info/info/layer-info-info-item-geometry-component";
import {
    LayerInfoInfoItemGeometryZoomComponent
} from "@/components/layer/info/info/layer-info-info-item-geometry-zoom-component";
import {
    LayerInfoInfoItemGeometryMeasureButton
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-button";
import {LayerInfoInfoItemGeometryMeasure} from "@/components/layer/info/info/layer-info-info-item-geometry-measure";
import {
    LayerInfoInfoItemGeometryMeasureBackButton
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-back-button";
import {LayerInfoInfoTypeComponent} from "@/components/layer/info/info/type/layer-info-info-type-component";
import {LayerInfoInfoTypeTextComponent} from "@/components/layer/info/info/type/layer-info-info-type-text-component";
import {LayerInfoInfoTypeUrlComponent} from "@/components/layer/info/info/type/layer-info-info-type-url-component";
import {LayerInfoInfoTypeFileComponent} from "@/components/layer/info/info/type/layer-info-info-type-file-component";
import {
    LayerInfoCharacteristicsLayerIndexComponent
} from "@/components/layer/info/characteristics/layer-info-characteristics-layer-index-component";
import {
    LayerInfoInfoItemLinkedDataButtonComponent
} from "@/components/layer/info/info/layer-info-info-item-linked-data-button-component";
import {
    LayerInfoInfoItemBreadCrumbComponent
} from "@/components/layer/info/info/layer-info-info-item-bread-crumb-component";
import {
    LayerInfoInfoItemFilterNavigationComponent
} from "@/components/layer/info/info/layer-info-info-item-filter-navigation-component";
import {
    LayerInfoCharacteristicsLayerButtonComponent
} from "@/components/layer/info/characteristics/layer-info-characteristics-layer-button-component";
import {
    LayerInfoInfoPluginFileComponent
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-file-component";
import {LayerInfoInfoPluginComponent} from "@/components/layer/info/info/plugin/layer-info-info-plugin-component";
import {
    LayerInfoInfoPluginKavel10Component
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-kavel10-component";
import {
    LayerInfoInfoPluginWordComponent
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-word-component";
import {
    LayerInfoInfoPluginCycloramaComponent
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-cyclorama-component";
import {
    LayerInfoInfoPluginOrbitComponent
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-orbit-component";
import {
    LayerInfoInfoItemMutationStandaloneEditComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-edit-component";
import {
    LayerInfoInfoItemMutationStandaloneRemoveComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-remove-component";
import {
    LayerInfoInfoItemMutationStandaloneEditGeometryComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-edit-geometry-component";
import {
    LayerInfoInfoItemMutationStandaloneEditGeometryCancelComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-edit-geometry-cancel-component";
import {
    LayerInfoInfoItemMutationStandaloneEditGeometrySaveComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-edit-geometry-save-component";
import {
    LayerInfoCharacteristicsLayerSelectComponent
} from "@/components/layer/info/characteristics/layer-info-characteristics-layer-select-component";
import {LayerInfoInfoItemSubTabComponent} from "@/components/layer/info/info/layer-info-info-item-sub-tab-component";
import {
    LayerInfoInfoItemHeaderArrowComponent
} from "@/components/layer/info/info/layer-info-info-item-header-arrow-component";
import {BookmarkDataSetComponent} from "@/components/bookmark/bookmark-data-set-component";
import {BookmarkGeoLocationComponent} from "@/components/bookmark/bookmark-geo-location-component";
import {
    LayerInfoLayerMenuButtonComponent
} from "@/components/layer/info/buttons/layer-info-layer-menu-button-component";
import {
    LayerInfoBookmarkInfoButtonComponent
} from "@/components/layer/info/buttons/layer-info-bookmark-info-button-component";
import {LayerInfoMutationButtonComponent} from "@/components/layer/info/buttons/layer-info-muation-button-component";
import {BookmarkSessionComponent} from "@/components/bookmark/bookmark-session-component";
import {
    BookmarkUserSessionModalComponent
} from "@/components/bookmark/usersession/bookmark-user-session-modal-component";
import {BookmarkPrintCesiumComponent} from "@/components/bookmark/bookmark-print-cesium-component";
import {isMobile} from "@/helpers/mobile-helper";
import {LayerInfoInfoTypeDateComponent} from "@/components/layer/info/info/type/layer-info-info-type-date-component";
import {ImageModelComponent} from "@/components/layout/image-model-component";
import {
    LayerInfoInfoPluginFileItemComponent
} from "@/components/layer/info/info/plugin/layer-info-info-plugin-file-item-component";
import {BookmarkNotificationComponent} from "@/components/bookmark/bookmark-notification-component";
import {
    LayerInfoInfoItemMutationStandaloneAddComponent
} from "@/components/layer/info/info/mutation/layer-info-info-item-mutation-standalone-add-component";
import {EmbedModelComponent} from "@/components/layout/embed-model-component.js";
import {
    LayerInfoInfoItemInfoNavigationComponent
} from "@/components/layer/info/info/layer-info-info-item-info-navigation-component.js";

const template = document.createElement('template');

export class LayerInfoComponent extends HTMLElement{
    constructor(){
        super();

        let width = window.settings.PopupBreedte
        let right = 'right:-70px'
        if(isMobile()) {
            right = ''
        }

        template.innerHTML = `
        <div class="info-menu position-absolute ml-2" style="width: ` + width +  `;right:70px;top:55px">
          <div class="info-menu-content pb-1 d-none">
<!--          <div class="info-menu-content pb-1">-->
              <bookmark-info class="d-none" data-test="bookmark_info"></bookmark-info>
              <bookmark-notifications class="d-none layer-info-block" data-test="bookmark_notifications"></bookmark-notifications>
              <bookmark-geo-location class="d-none layer-info-block"></bookmark-geo-location>
              <bookmark-print class="d-none layer-info-block"></bookmark-print>
              <bookmark-print-cesium class="d-none layer-info-block"></bookmark-print-cesium>
              <bookmark-data-set class="d-none layer-info-block"></bookmark-data-set>
              <bookmark-session class="d-none layer-info-block" data-test="bookmark_session"></bookmark-session>
              <bookmark-right-mouse-button class="d-none layer-info-block"></bookmark-right-mouse-button>
              
              <layer-info-info class="d-none layer-info-block"></layer-info-info>
              <layer-info-filter class="d-none layer-info-block"></layer-info-filter>
              <layer-info-mutation class="d-none layer-info-block"></layer-info-mutation>
              <layer-info-tools class="d-none layer-info-block"></layer-info-tools>
              <layer-info-info-geometry-measure class="d-none layer-info-block"></layer-info-info-geometry-measure>
              <layer-info-legend class="d-none layer-info-block"></layer-info-legend>
              <layer-info-characteristics class="d-none layer-info-block"></layer-info-characteristics>
<!--              <layer-info-tools class="layer-info-block"></layer-info-tools>-->

            </div>
        </div>
          <div id="divInfoMenuButtons" class="info-menu-buttons info-menu-buttons-open p-0">
              <layer-info-layer-menu-button class="d-block d-md-none"></layer-info-layer-menu-button>
              <layer-info-characteristics-button class="divCharacteristics d-none"></layer-info-characteristics-button>
              <layer-info-info-button class="divInformation d-none"></layer-info-info-button>
              <layer-info-filter-button class="d-none"></layer-info-filter-button>
              <layer-info-mutation-button class="d-none"></layer-info-mutation-button>
              <layer-info-tools-button class="divMeasureFunctions d-none"></layer-info-tools-button>
              <layer-info-legend-button class="d-none"></layer-info-legend-button>
<!--              <layer-info-bookmark-info-button class="d-block d-md-none"</layer-info-bookmark-info-button>-->
          </div>
        
        <image-modal></image-modal>
        <embed-modal></embed-modal>
`;

        initWebComponent(this, template)
        initHideButton()

        window.windowSettings = {}
        window.windowModalSettings = {}

        if(!isMobile()) {
            initInteract()
        }
    }
}

window.customElements.define("layer-info-button", LayerInfoButtonComponent);

window.customElements.define("layer-info-characteristics-button", LayerInfoCharacteristicsButtonComponent);
window.customElements.define("layer-info-characteristics", LayerInfoCharacteristicsComponent);
window.customElements.define("layer-info-characteristics-layer-index", LayerInfoCharacteristicsLayerIndexComponent);
window.customElements.define("layer-info-characteristics-layer-button", LayerInfoCharacteristicsLayerButtonComponent);
window.customElements.define("layer-info-characteristics-layer-select", LayerInfoCharacteristicsLayerSelectComponent);

window.customElements.define("layer-info-info-button", LayerInfoInfoButtonComponent);

window.customElements.define("layer-info-info-type", LayerInfoInfoTypeComponent);
window.customElements.define("layer-info-info-type-text", LayerInfoInfoTypeTextComponent);
window.customElements.define("layer-info-info-type-url", LayerInfoInfoTypeUrlComponent);
window.customElements.define("layer-info-info-type-file", LayerInfoInfoTypeFileComponent);
window.customElements.define("layer-info-info-type-date", LayerInfoInfoTypeDateComponent);

window.customElements.define("layer-info-info", LayerInfoInfoComponent);
window.customElements.define("layer-info-info-item", LayerInfoInfoItemComponent);
window.customElements.define("layer-info-info-item-sub-tab", LayerInfoInfoItemSubTabComponent);

window.customElements.define("layer-info-info-plugin-file", LayerInfoInfoPluginFileComponent);
window.customElements.define("layer-info-info-plugin-file-item", LayerInfoInfoPluginFileItemComponent);
window.customElements.define("layer-info-info-plugin-kavel10", LayerInfoInfoPluginKavel10Component);
window.customElements.define("layer-info-info-plugin-word", LayerInfoInfoPluginWordComponent);
window.customElements.define("layer-info-info-plugin-cyclorama", LayerInfoInfoPluginCycloramaComponent);
window.customElements.define("layer-info-info-plugin-orbit", LayerInfoInfoPluginOrbitComponent);
window.customElements.define("layer-info-info-plugin", LayerInfoInfoPluginComponent);

window.customElements.define("layer-info-info-item-header", LayerInfoInfoItemHeaderComponent);
window.customElements.define("layer-info-info-item-header-arrow", LayerInfoInfoItemHeaderArrowComponent);
window.customElements.define("layer-info-info-item-filter-navigation", LayerInfoInfoItemFilterNavigationComponent);
window.customElements.define("layer-info-info-item-info-navigation", LayerInfoInfoItemInfoNavigationComponent);
window.customElements.define("layer-info-info-linked-data-button", LayerInfoInfoItemLinkedDataButtonComponent);
window.customElements.define("layer-info-info-bread-crumb", LayerInfoInfoItemBreadCrumbComponent);
window.customElements.define("layer-info-info-mutation-standalone-edit", LayerInfoInfoItemMutationStandaloneEditComponent);
window.customElements.define("layer-info-info-mutation-standalone-add", LayerInfoInfoItemMutationStandaloneAddComponent);
window.customElements.define("layer-info-info-mutation-standalone-edit-geometry", LayerInfoInfoItemMutationStandaloneEditGeometryComponent);
window.customElements.define("layer-info-info-mutation-standalone-remove", LayerInfoInfoItemMutationStandaloneRemoveComponent);
window.customElements.define("layer-info-info-mutation-standalone-edit-geometry-cancel", LayerInfoInfoItemMutationStandaloneEditGeometryCancelComponent);
window.customElements.define("layer-info-info-mutation-standalone-edit-geometry-save", LayerInfoInfoItemMutationStandaloneEditGeometrySaveComponent);

window.customElements.define("layer-info-info-geometry", LayerInfoInfoItemGeometryComponent);
window.customElements.define("layer-info-info-geometry-zoom", LayerInfoInfoItemGeometryZoomComponent);

window.customElements.define("layer-info-info-geometry-measure-button", LayerInfoInfoItemGeometryMeasureButton);
window.customElements.define("layer-info-info-geometry-measure", LayerInfoInfoItemGeometryMeasure);
window.customElements.define("layer-info-info-geometry-measure-back-button", LayerInfoInfoItemGeometryMeasureBackButton);

window.customElements.define("layer-info-legend-button", LayerInfoLegendButtonComponent);
window.customElements.define("layer-info-legend", LayerInfoLegendComponent);

window.customElements.define("layer-info-filter", LayerInfoFilterComponent);
window.customElements.define("layer-info-filter-button", LayerInfoFilterButtonComponent);

window.customElements.define("layer-info-mutation", LayerInfoMutationComponent);
window.customElements.define("layer-info-mutation-button", LayerInfoMutationButtonComponent);

window.customElements.define("layer-info-tools", LayerInfoToolsComponent);
window.customElements.define("layer-info-tools-button", LayerInfoToolsButtonComponent);

window.customElements.define("bookmark-info", BookmarkInfoComponent);
window.customElements.define("bookmark-right-mouse-button", BookmarkRightMouseButtonsComponent);
window.customElements.define("bookmark-print", BookmarkPrintComponent);
window.customElements.define("bookmark-print-cesium", BookmarkPrintCesiumComponent);
window.customElements.define("bookmark-data-set", BookmarkDataSetComponent);
window.customElements.define("bookmark-session", BookmarkSessionComponent);
window.customElements.define("bookmark-geo-location", BookmarkGeoLocationComponent);
window.customElements.define("bookmark-notifications", BookmarkNotificationComponent);

window.customElements.define("layer-info-layer-menu-button", LayerInfoLayerMenuButtonComponent);
window.customElements.define("layer-info-bookmark-info-button", LayerInfoBookmarkInfoButtonComponent);

window.customElements.define("image-modal", ImageModelComponent);
window.customElements.define("embed-modal", EmbedModelComponent);
